<template>
  <div class="current-bid-card">
    <span class="current-bid-card__label">Current bid</span>
    <span class="current-bid-card__amount">${{ (amount || 0).toLocaleString() }}</span>
    <span class="current-bid-card__leader">
      <template v-if="leaderBadge">
        <SourceBadge :source="leaderSource" :size="16" />{{ leaderBadge }}
      </template>
      <template v-else>Awaiting opening bid</template>
    </span>
  </div>
</template>

<script setup>
import SourceBadge from '../SourceBadge/SourceBadge.vue';

// The standing high bid, in the console's reference-gold treatment.
//
// It read the live bidding state through a composable and took the item record
// alongside it to find the leader's bid source — two data paths for one card.
// Both are props now, and the gold is a token rather than three hard-coded
// yellows.
defineOptions({ name: 'CurrentBidCard' });

defineProps({
  amount: { type: Number, default: 0 },
  // floor | online | prebid — where the standing bid came from.
  leaderSource: { type: String, default: 'floor' },
  // The high bidder's badge. Null means nobody has bid, which is a different
  // statement from a bid of zero and is why the card says so in words.
  leaderBadge: { type: String, default: null },
});
</script>

<style scoped>
.current-bid-card {
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--p-current-bid-card-background);
  border: var(--p-current-bid-card-border-width) solid var(--p-current-bid-card-border-color);
  border-radius: var(--p-current-bid-card-border-radius);
  padding: var(--p-current-bid-card-padding);
  gap: var(--p-current-bid-card-gap);
}

.current-bid-card__label {
  text-transform: uppercase;
  font-size: var(--p-current-bid-card-label-font-size);
  font-weight: var(--p-current-bid-card-label-font-weight);
  letter-spacing: var(--p-current-bid-card-label-letter-spacing);
  color: var(--p-current-bid-card-label-color);
}

.current-bid-card__amount {
  font-family: var(--p-current-bid-card-amount-font-family);
  font-size: var(--p-current-bid-card-amount-font-size);
  font-weight: var(--p-current-bid-card-amount-font-weight);
  letter-spacing: var(--p-current-bid-card-amount-letter-spacing);
  line-height: var(--p-current-bid-card-amount-line-height);
  color: var(--p-current-bid-card-amount-color);
  font-variant-numeric: tabular-nums;
}

.current-bid-card__leader {
  display: inline-flex;
  align-items: center;
  gap: var(--p-current-bid-card-leader-gap);
  font-size: var(--p-current-bid-card-leader-font-size);
  font-weight: var(--p-current-bid-card-leader-font-weight);
  color: var(--p-current-bid-card-leader-color);
}
</style>
